import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {Usuario} from "../models/usuario";
import {Perfil} from "../models/perfil";
import {UsuarioLdap} from "../models/usuario-ldap";

@Injectable({
    providedIn: 'root'
})
export class UsuarioService {

    private api_url = environment.api_url + "/usuario";

    constructor(private http: HttpClient) {

    }

    listAll(perfil: string = null, nome: string = null, cpf: string = null, email: string = null): Observable<Usuario[]> {
        let url: string = this.api_url;
        url += (perfil) ? ('/' + perfil) : ('/0');
        url += (nome) ? ('/' + nome) : ('/0');
        url += (cpf) ? ('/' + cpf) : ('/0');
        url += (email) ? ('/' + email) : ('/0');
        return this.http.get(url).pipe(map((res: any) => {
            let usuarios: Array<Usuario> = [];
            if (res.data && res.data.length > 0) {
                res.data.forEach((data: any) => {
                    let perfil: Perfil = data.perfil as Perfil;
                    let usuario: Usuario = data as Usuario;
                    usuario.perfil = perfil;
                    usuarios.push(usuario);
                });
            }
            return usuarios;
        }));
    }

    findByCpf(cpf: string): Observable<Usuario> {
        let url: string = environment.api_url + "/cadastro-externo/cpf/" + cpf;
        return this.http.get(url).pipe(map((res: any) => {
            let usuario: Usuario = res.data[0] as Usuario;
            return usuario;
        }));
    }

    findByCnpj(cnpj: string): Observable<Usuario> {
        let url: string = environment.api_url + "/cadastro-externo/cnpj/" + cnpj;
        return this.http.get(url).pipe(map((res: any) => {
            let usuario: Usuario = res.data[0] as Usuario;
            return usuario;
        }));
    }

    findByMunicipio(cod_municipio: string): Observable<Usuario> {
        let url: string = environment.api_url + "/cadastro-externo/municipio/" + cod_municipio;
        return this.http.get(url).pipe(map((res: any) => {
            let usuario: Usuario = res.data[0] as Usuario;
            return usuario;
        }));
    }

    findByToken(): Observable<Usuario> {
        let url: string = this.api_url + "/show";
        return this.http.get(url).pipe(map((res: any) => {
            let perfil: Perfil = res.perfil as Perfil;
            let usuario: Usuario = res as Usuario;
            usuario.perfil = perfil;
            return usuario;
        }));
    }

    findById(id: number): Observable<Usuario> {
        let url: string = this.api_url + "/show/" + id;
        return this.http.get(url).pipe(map((res: any) => {
            let perfil: Perfil = res.perfil as Perfil;
            let usuario: Usuario = res as Usuario;
            usuario.perfil = perfil;
            return usuario;
        }));
    }

    findByEmail(email: string): Observable<Usuario> {
        return this.http.get(`${environment.api_url}/cadastro-externo/email/${email}`).pipe(
            map((response: Usuario) => {
                return response;
            }));
    }

    findVisualizarExterno(id: number): Observable<Usuario> {
        let url: string = environment.api_url + "/visualizar-cadastro-externo/" + id;
        return this.http.get(url).pipe(map((res: any) => {
            let perfil: Perfil = res.perfil as Perfil;
            let usuario: Usuario = res as Usuario;
            usuario.perfil = perfil;
            return usuario;
        }));
    }

    save(usuario: Usuario): Observable<any> {
        let url: string = this.api_url;
        let http;
        if (usuario.cod_usuario) {
            http = this.http.put(url + "/" + usuario.cod_usuario, usuario);
        } else {
            http = this.http.post(url, usuario);
        }
        return http.pipe(map((res: any) => {
            return res;
        }));
    }

    saveExterno(usuario: Usuario): Observable<any> {
        let url: string = environment.api_url + "/cadastro-externo/";
        let perfil: Perfil = usuario.perfil as Perfil;
        let http;
        if (usuario.cod_usuario) {
            http = this.http.put(url + usuario.cod_usuario, usuario);
        } else {
            http = this.http.post(url, usuario);
        }
        return http.pipe(map((res: any) => {
            return res;
        }));
    }

    findByIdExterno(id: number): Observable<Usuario> {
        let url: string = environment.api_url + "/cadastro-externo" + "/show/" + id;
        return this.http.get(url).pipe(map((res: any) => {
            let perfil: Perfil = res.perfil as Perfil;
            let usuario: Usuario = res as Usuario;
            usuario.perfil = perfil;
            return usuario;
        }));
    }

    recusaAtivacaoUsario(cod_usuario): Observable<any> {
        let url: string = this.api_url + "/recusaAtivacaoUsuario";
        return this.http.post(url, {cod_usuario}).pipe(map((res: any) => {
            return res;
        }));
    }

    msgUsuario(formData): Observable<any> {
        let url: string = this.api_url + "/msgUsuario";
        return this.http.post(url, formData).pipe(map((res: any) => {
            return res;
        }));
    }

    update(usuario: Usuario): Observable<any> {
        let url: string = this.api_url;
        let http = this.http.put(url, usuario);
        return http.pipe(map((res: any) => {
            return res.data;
        }));
    }

    validate(id: number): Observable<any> {
        let url: string = this.api_url + "/validate/" + id;
        let http = this.http.get(url);
        return http.pipe(map((res: any) => {
            return res;
        }));
    }

    solicitacaoDownload(id: number): void {
        let url: string = environment.api_url + "/cadastro-externo/solicitacaoDownload/" + id;
        window.open(url, '_blank');
    }

    solicitacaoDownloadExterno(id: number): void {
        let url: string = environment.api_url + "/cadastro-externo/solicitacaoDownload/" + id;
        window.open(url, '_blank');
    }

    completaCadastroAd(usuario: UsuarioLdap): Observable<any> {
        return this.http.post(`${environment.api_url}/ldap/completar-cadastro-ad`, usuario).pipe(
            map((response: UsuarioLdap) => {
                return response;
            }),
            catchError((error: any) => {
                return throwError(error);
            })
        );
    }
}
